/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";

import { sanitizer } from "../../../utility/sanitize";

type Props = {
  html: string;
};

export const EventAdditionalSection: React.FC<Props> = (props) => {
  return (
    <div
      id="act_info"
      css={containerStyle}
      dangerouslySetInnerHTML={{ __html: sanitizer(props.html) }}
    />
  );
};

const containerStyle = css`
  #artists-grid {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 48px;
    max-width: 980px;
    margin-left: auto;
    margin-right: auto;
    color: #fff;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  }
  #artists-grid *,
  #artists-grid *::before,
  #artists-grid *::after {
    box-sizing: inherit;
  }
  #artists-grid::before,
  #artists-grid::after {
    content: none;
  }
  #artists-title {
    margin-top: 48px;
    width: 100%;
    letter-spacing: 1px;
  }
  #artists-title > h2 {
    margin: 0 0 5px;
    padding: 5px 0 0 15px;
    border-left: 5px solid #00c2ae;
    font-family: "din-condensed", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 35px;
    line-height: 1;
    color: #000;
  }
  #artists-title > p {
    margin: 0;
    padding-left: 21px;
    font-size: 12px;
    line-height: 1.3;
    color: #000;
  }
  #artists-groups {
    margin-top: 24px;
    font-weight: bold;
    line-height: 1.8;
    color: #000;
  }
  #artists-grid > article {
    position: relative;
    width: 47.5%;
    margin-bottom: 40px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    color: #000;
    overflow: visible;
  }
  #artists-grid > article > div:first-of-type {
    position: relative;
  }
  #artists-grid > article > div:first-of-type > img {
    display: block;
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    object-position: 50% 0%;
    border-radius: 5px 5px 0 0;
  }
  #artists-grid > article > div:first-of-type > p {
    position: absolute;
    top: -20px;
    left: -8px;
    width: 65px;
    height: 42px;
    margin: 0;
    padding-top: 9px;
    font-family: "din-condensed", sans-serif;
    font-weight: 400;
    font-style: normal;
    color: #01ffe1;
    font-size: 16px;
    text-align: center;
    background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjRweCIgaGVpZ2h0PSI0MHB4IiB2aWV3Qm94PSIwIDAgNjQgNDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT4wNF9hdG9tL2xhYmVsL2FjdDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPgogICAgICAgIDxwb2x5Z29uIGlkPSJwYXRoLTEiIHBvaW50cz0iMCAwIDggOCA4IDAiPjwvcG9seWdvbj4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSIwNF9hdG9tL2xhYmVsL2FjdCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAuNSwwLjUgTDAuNSwzMS41IEw1MS4xOTgwNTAyLDMxLjUgTDYzLjUsMTguODg5NzAzOSBMNjMuNSwwLjUgTDAuNSwwLjUgWiIgaWQ9ImJnIiBzdHJva2U9IiMwMEZGRTUiIGZpbGw9IiMxMzE4MTkiPjwvcGF0aD4KICAgICAgICA8ZyBpZD0iUmVjdGFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMzIuMDAwMDAwKSI+CiAgICAgICAgICAgIDxtYXNrIGlkPSJtYXNrLTIiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgPHVzZSBpZD0iTWFzayIgZmlsbD0iIzI5MzQzQSIgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgIDxyZWN0IGZpbGw9IiMwRjVENjAiIG1hc2s9InVybCgjbWFzay0yKSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC41OTYxOTQsIDMuODUzNTUzKSByb3RhdGUoLTQ1LjAwMDAwMCkgdHJhbnNsYXRlKC00LjU5NjE5NCwgLTMuODUzNTUzKSAiIHg9IjQuMDk2MTk0MDgiIHk9Ii0yLjE0NjQ0NjYxIiB3aWR0aD0iMSIgaGVpZ2h0PSIxMiI+PC9yZWN0PgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    line-height: 1;
    z-index: 1;
    pointer-events: none;
  }
  #artists-grid > article > div:nth-of-type(2) {
    padding: 16px;
  }
  #artists-grid > article > div:nth-of-type(2) > h3 {
    margin: 0;
    font-size: 15px;
    text-align: center;
    line-height: 1.4em;
    white-space: pre-line;
    font-weight: 700;
  }
  #artists-grid > article > p:last-of-type {
    position: absolute;
    bottom: 10px;
    right: 7%;
    margin: 0;
    color: rgba(0, 194, 174, 0.25);
    font-weight: bold;
    font-size: 20px;
    line-height: 1;
  }
  @media screen and (min-width: 768px) {
    #artists-title {
      display: flex;
      align-items: center;
    }
    #artists-title > h2 {
      margin-bottom: 0;
      letter-spacing: 3px;
    }
    #artists-title > p {
      font-size: 16px;
    }
    #artists-grid::before {
      content: "";
      display: block;
      width: 24%;
      order: 1;
    }
    #artists-grid::after {
      content: "";
      display: block;
      width: 24%;
    }
    #artists-grid > article {
      width: 24%;
      margin-bottom: 60px;
    }
    #artists-grid > article > div:first-of-type > p {
      width: 100px;
      height: 48px;
      padding-top: 12px;
      font-size: 20px;
      background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTIwcHgiIGhlaWdodD0iNDhweCIgdmlld0JveD0iMCAwIDEyMCA0OCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTUuMiAoNzgxODEpIC0gaHR0cHM6Ly9za2V0Y2hhcHAuY29tIC0tPgogICAgPHRpdGxlPjA0X2F0b20vbGFiZWwvYWN0X3BjPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IjA0X2F0b20vbGFiZWwvYWN0X3BjIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iMDQvYXRvbS9sYWJlbC9ncm4iPgogICAgICAgICAgICA8cGF0aCBkPSJNMSwxIEwxLDM5IEwxMDkuNTg1Nzg2LDM5IEwxMTksMjkuNTg1Nzg2NCBMMTE5LDEgTDEsMSBaIiBpZD0iYmciIHN0cm9rZT0iIzAwRkZFNSIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSIjMTMxODE5Ij48L3BhdGg+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjIwNzEwNjc4LDQwLjUgTDcuNSw0Ni43OTI4OTMyIEw3LjUsNDAuNSBMMS4yMDcxMDY3OCw0MC41IFoiIGlkPSJGaWxsLTEiIHN0cm9rZT0iIzBGNUQ2MCIgZmlsbD0iIzI5MzQzQSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+");
    }
    #artists-grid > article > div:nth-of-type(2) > h3 {
      font-size: 20px;
    }
    #artists-grid > article > p:last-of-type {
      right: 20px;
    }
  }
`;
